import { formatPhoneValue } from "./field-utils";

export const PHONE_KEYWORDS = ["phone", "mobile", "cell", "telephone", "tel"];

/** Check if a key contains any phone-related keyword (handles keys with extra info like "Phone Number (optional)") */
function isPhoneKey(key: string): boolean {
  const lower = key.toLowerCase().trim();
  return PHONE_KEYWORDS.some((keyword) => lower.includes(keyword));
}

/**
 * Extract a phone number from form response_data, handling all known field variations.
 * Phone values can be either:
 * - An object: { phone: string, countryDialCodeId: number | null }
 * - A plain string
 *
 * Matches keys containing phone-related keywords (e.g. "Phone Number (required)").
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractPhoneFromResponseData(rd: Record<string, any> | undefined | null): string {
  if (!rd) return "";

  for (const [key, value] of Object.entries(rd)) {
    if (isPhoneKey(key)) {
      if (value && typeof value === "object" && "phone" in value) {
        return formatPhoneValue(value);
      }
      if (typeof value === "string" && value.trim()) {
        return value.trim();
      }
    }
  }
  return "";
}

/**
 * Normalize a phone number for search comparison by stripping all non-digit characters.
 * @example normalizePhone("+1 (949) 537-9675") => "19495379675"
 */
export function normalizePhone(phone: string): string {
  return phone.replace(/\D/g, "");
}
